export const DEFAULT_FRONTEND_SETTINGS_MODEL = {
  frontend_config: {}
};

const BASE_FRONTEND_SETTINGS_SCHEMA = {
  fields: [
    {
      type: "jsonField",
      model: "frontend_config",
    },
    {
      type: "jsonField",
      model: "shop_config"
    }
  ]
};

export const NEW_FRONTEND_SETTINGS_SCHEMA = BASE_FRONTEND_SETTINGS_SCHEMA;

export const EDIT_FRONTEND_SETTINGS_SCHEMA = BASE_FRONTEND_SETTINGS_SCHEMA;

export const FRONTEND_SETTINGS_OPTIONS = {
  validateAfterLoad: false,
  validateAfterChanged: true,
  validateAsync: true
};

export default {
  DEFAULT_FRONTEND_SETTINGS_MODEL,
  NEW_FRONTEND_SETTINGS_SCHEMA,
  EDIT_FRONTEND_SETTINGS_SCHEMA,
  FRONTEND_SETTINGS_OPTIONS
};
